// @ts-nocheck
import * as Types from '../../../../lib/__generated/graphql.types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { myFetcher } from '@src/lib/fetchConfig.dtc';
export type ParentPageFragmentFragment = { __typename?: 'Page', name?: string | null, slug?: string | null, parentPage?: { __typename?: 'Page', name?: string | null, slug?: string | null, parentPage?: { __typename?: 'Page', name?: string | null, slug?: string | null, parentPage?: { __typename?: 'Page', name?: string | null, slug?: string | null, parentPage?: { __typename?: 'Page', name?: string | null, slug?: string | null, parentPage?: { __typename?: 'Page', name?: string | null, slug?: string | null } | null } | null } | null } | null } | null };

export type BreadCrumbsQueryQueryVariables = Types.Exact<{
  slug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type BreadCrumbsQueryQuery = { __typename?: 'Query', pageCollection?: { __typename?: 'PageCollection', items: Array<(
      { __typename?: 'Page' }
      & ParentPageFragmentFragment
    ) | null> } | null };

export const ParentPageFragmentFragmentDoc = `
    fragment ParentPageFragment on Page {
  name
  slug
  parentPage {
    name
    slug
    parentPage {
      name
      slug
      parentPage {
        name
        slug
        parentPage {
          name
          slug
          parentPage {
            name
            slug
          }
        }
      }
    }
  }
}
    `;
export const BreadCrumbsQueryDocument = `
    query BreadCrumbsQuery($slug: String) {
  pageCollection(where: {slug: $slug}) {
    items {
      ...ParentPageFragment
    }
  }
}
    ${ParentPageFragmentFragmentDoc}`;
export const useBreadCrumbsQueryQuery = <
      TData = BreadCrumbsQueryQuery,
      TError = unknown
    >(
      variables?: BreadCrumbsQueryQueryVariables,
      options?: UseQueryOptions<BreadCrumbsQueryQuery, TError, TData>
    ) =>
    useQuery<BreadCrumbsQueryQuery, TError, TData>(
      variables === undefined ? ['BreadCrumbsQuery'] : ['BreadCrumbsQuery', variables],
      myFetcher<BreadCrumbsQueryQuery, BreadCrumbsQueryQueryVariables>(BreadCrumbsQueryDocument, variables),
      options
    );

useBreadCrumbsQueryQuery.getKey = (variables?: BreadCrumbsQueryQueryVariables) => variables === undefined ? ['BreadCrumbsQuery'] : ['BreadCrumbsQuery', variables];
;

useBreadCrumbsQueryQuery.fetcher = (variables?: BreadCrumbsQueryQueryVariables, options?: RequestInit['headers']) => myFetcher<BreadCrumbsQueryQuery, BreadCrumbsQueryQueryVariables>(BreadCrumbsQueryDocument, variables, options);